// extracted by mini-css-extract-plugin
export default {"editButton":"_fa2b5792","value":"_f9e4b473","wrapper":"_c7d7014b","emptyValuePlaceholder":"_692a0765"};